import React from "react";

import { string, func } from "prop-types";

import { salaryFrequencyOptions } from "../../../helpers";

import { SelectListGroup, NumberFieldGroup } from "../../../common";
import { toInt } from "../../../helpers/helpers";
import * as style from "./styles.module.scss";

const MinSalary = ({ minSalary, salaryFrequency, handleChange }) => {
  return (
    <div className="mt-1">
      Minimum salary
      <div
        className="form-row align-items-center"
        style={{ marginTop: "10px" }}
      >
        <div className="col-6 col-lg-7">
          <div className="input-group">
            <NumberFieldGroup
              value={minSalary}
              onChange={(e) => handleChange("minSalary", toInt(e.target.value))}
              classes="form-control register_field"
            />
          </div>
        </div>
        <div className="col-6 col-lg-5">
          <SelectListGroup
            value={salaryFrequency}
            isBold
            onChange={(e) => {
              handleChange("salaryFrequency", e.target.value);
            }}
            options={salaryFrequencyOptions}
            classes="register_field register_field-dropdown"
          />
        </div>
      </div>
    </div>
  );
};

MinSalary.propTypes = {
  minSalary: string.isRequired,
  salaryFrequency: string.isRequired,
  handleChange: func.isRequired,
};

export default MinSalary;
